import { ICommonIconProps } from './types';

/**
 * -----------------------------------------------------------------------------
 * It renders the excel file icon
 */
export function ExcelFileIcon({
  className = 'text-green-800',
}: Readonly<ICommonIconProps>) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" width={16}>
      <path
        d="M6.998 6.998v-2a2 2 0 0 1 2-2.001h10.005a2 2 0 0 1 2 2v14.006a2 2 0 0 1-2 2.001H8.999a2 2 0 0 1-2.001-2v-2.002"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
      <rect
        height={10.004}
        rx={2}
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        width={10.004}
        x={3.997}
        y={6.998}
      />
      <path
        d="M21.004 9.079H14M21.004 15.001H14M14 2.997v18.007M10.566 13.751l-3-3.502M7.565 13.751l3.001-3.502"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
    </svg>
  );
}
